import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Company } from '../index';
import { useAppQuery } from '../use-app-query.hook';
import { SharedCapTableLink } from './shared-cap-table.types';

export const useSharedCapTableLinks = (enabled = true) => {
  const { selectedCompanyId: companyId } = Company.useSelected();

  const {
    data: links = [],
    isFetched,
    isLoading,
  } = useAppQuery({
    enabled: !!companyId && enabled,
    queryKey: [QueryKey.SHARED_CAP_TABLE_LINKS, companyId],
    queryFn: () =>
      ApiService.get<SharedCapTableLink[]>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'shared-cap-table-links'],
      }),
  });

  return { isFetched, isLoading, links };
};
